import { render, staticRenderFns } from "./mbFugaiswiper.vue?vue&type=template&id=7c5dbc7d&scoped=true&"
import script from "./mbFugaiswiper.vue?vue&type=script&lang=js&"
export * from "./mbFugaiswiper.vue?vue&type=script&lang=js&"
import style0 from "./mbFugaiswiper.vue?vue&type=style&index=0&id=7c5dbc7d&scoped=true&lang=css&"
import style1 from "./mbFugaiswiper.vue?vue&type=style&index=1&id=7c5dbc7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5dbc7d",
  null
  
)

export default component.exports